import {
	programGroupFromBE,
	gbProgramGroupFromBE,
} from '@common/api/programGroups';
import { scheduleFromBE } from '@common/api/schedules';
import backend from '@common/backend';

const BASE = '/schedulePrograms';

export interface IScheduleProgramFromBe {
	id: number;
	format: 'Homework' | 'Homework + lesson' | 'OSSD';
	is_archive: null;
	programGroup: any; // @TODO: TS
	schedule: any; // @TODO: TS
	type: 'Regular' | 'Individual';
}

export const scheduleProgramFromBE = ({
	schedule,
	programGroup,
	...scheduleProgram
}: IScheduleProgramFromBe) => ({
	...scheduleProgram,
	schedule: scheduleFromBE(schedule),
	programGroup: programGroup ? programGroupFromBE(programGroup) : null,
});

export const gbScheduleProgramFromBE = ({
	program_group,
	...scheduleProgram
}: any) => ({
	...scheduleProgram,
	programGroup: program_group ? gbProgramGroupFromBE(program_group) : null,
});

export const getSchedulePrograms = async (schedule_id: number, query?: any) =>
	backend
		.get(`${BASE}/`, {
			params: {
				schedule_id,
				...query,
			},
		})
		.then((schedulePrograms: IScheduleProgramFromBe[]) =>
			schedulePrograms.map(scheduleProgramFromBE),
		);

export const createScheduleProgram = async (data: any) =>
	backend.post(`${BASE}/`, data).then(scheduleProgramFromBE);

export const deleteScheduleProgram = async (scheduleProgramId: any) =>
	backend.delete(`${BASE}/${scheduleProgramId}`);

export const saveScheduleProgram = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, data).then(scheduleProgramFromBE);

export const showScheduleProgram = (scheduleProgramId: number) =>
	backend.get(`${BASE}/${scheduleProgramId}`).then(scheduleProgramFromBE);
